import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
//import api_base_url from "../../config";
import axiosInstance from "../../../../api/axiosInstance";

const initialState = {
  uploadedFile: null,
  errorMessage: null,
  uploadProgress: 0,
  open: false,
  jobTypes: [],
  selectedJob: { id: "", jobType: "" },
  jobRetrievalStatus: "idle",
  jobRetrievalError: null,
  uploadResponse: null,
  uploadedJobId: null,
  uploadJobDataStatus: "idle",
  uploadJobDataError: null,
  meetingResponse: null,
  meetingDetailsStatus: "idle",
  meetingDetailsError: null,
  existingjobDetails: null,
  existingjobDetailsStatus: "idle",
  existingjobDetailsError: null,
};

export const fetchJobTypes = createAsyncThunk(
  "fileUpload/fetchJobTypes",
  async () => {
    // if (!token) {
    //   throw new Error("Missing user token");
    // }
    const response = await axiosInstance.get(
      `api/Jobs/GetJobTypes`,
      {
        headers: {
         // Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  }
);

export const uploadJobData = createAsyncThunk(
  "fileUpload/uploadJobData",
  async ({ body, file }, { rejectWithValue }) => {
    // console.log("token", token);
    // if (!token) {
    //   throw new Error("Missing user token");
    // }
    console.log("JSON body:", JSON.stringify(body));

    const formData = new FormData();
    formData.append("file", file);
    formData.append("data", JSON.stringify(body));

    try {
      const response = await axiosInstance.post(
        `api/Jobs/uploadData`,
        formData,
        // {
        //   headers: {
        //     Authorization: `Bearer ${token}`,
        //   },
        // }
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const submitMeetingDetails = createAsyncThunk(
  "fileUpload/submitMeetingDetails",
  async ({ body }) => {
    // if (!token) {
    //   throw new Error("Missing user token");
    // }

    const response = await axiosInstance.post(
      `api/Jobs/MeetingDetails`,
      body,
      {
        headers: {
         // Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  }
);  

export const getJobDetails = createAsyncThunk(
  "fileUpload/getJobDetails",
  async ({ jobId }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `api/Jobs/GetJobDetails?JobId=${jobId}`,
        {
          headers: {
           // Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const fileUploadSlice = createSlice({
  name: "fileUpload",
  initialState,
  reducers: {
    setFile(state, action) {
      state.uploadedFile = {
        name: action.payload.name,
      };
    },
    setErrorMessage(state, action) {
      state.errorMessage = action.payload;
    },
    setProgress(state, action) {
      state.uploadProgress = action.payload;
    },
    toggleDialog(state) {
      state.open = !state.open;
    },
    setSelectedJobType(state, action) {
      state.selectedJob = action.payload;
    },
    resetUploadStatus(state) {
      state.uploadJobDataStatus = "idle";
      state.uploadJobDataError = null;
      state.uploadedFile = null; 
      state.uploadProgress = 0; 
      state.existingjobDetails = null;
      state.existingjobDetailsError = null;
      state.existingjobDetailsStatus = "idle"
      //state.selectedJob = { id: "", jobType: "" };
      //state.errorMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchJobTypes.pending, (state) => {
        state.jobRetrievalStatus = "loading";
        state.jobRetrievalError = null;
      })
      .addCase(fetchJobTypes.fulfilled, (state, action) => {
        state.jobRetrievalStatus = "succeeded";
        state.jobTypes = action.payload;
      })
      .addCase(fetchJobTypes.rejected, (state, action) => {
        state.jobRetrievalStatus = "failed";
        state.jobRetrievalError = action.error.message;
        state.jobTypes = [];
      })
      .addCase(uploadJobData.pending, (state) => {
        state.uploadJobDataStatus = "loading";
        state.uploadJobDataError = null;
      })
      .addCase(uploadJobData.fulfilled, (state, action) => {
        state.uploadJobDataStatus = "succeeded";
        const response = action.payload;
        state.uploadResponse = response;
        if(response.jobId) {
          state.uploadedJobId = response.jobId;
        }
      })
      .addCase(uploadJobData.rejected, (state, action) => {
        state.uploadJobDataStatus = "failed";
        state.uploadJobDataError = action.payload;
        state.uploadResponse = null;
      })
      .addCase(submitMeetingDetails.pending, (state) => {
        state.meetingDetailsStatus = "loading";
        state.meetingDetailsError = null;
      })
      .addCase(submitMeetingDetails.fulfilled, (state, action) => {
        state.meetingDetailsStatus = "succeeded";
        state.meetingResponse = action.payload;
      })
      .addCase(submitMeetingDetails.rejected, (state, action) => {
        state.meetingDetailsStatus = "failed";
        state.meetingDetailsError = action.error.message;
        state.meetingResponse = null;
      })
      .addCase(getJobDetails.pending, (state) => {
        state.existingjobDetailsStatus = "loading";
        state.existingjobDetailsError = null;
      })
      .addCase(getJobDetails.fulfilled, (state, action) => {
        state.existingjobDetailsStatus = "succeeded";
        state.existingjobDetails = action.payload;
      })
      .addCase(getJobDetails.rejected, (state, action) => {
        state.existingjobDetailsStatus = "failed";
        state.existingjobDetailsError = action.error.message;
        state.existingjobDetails = null;
      });
  },
});

export const {
  setFile,
  setErrorMessage,
  setProgress,
  toggleDialog,
  setSelectedJobType,
  setTempFilePath,
  resetUploadStatus,
} = fileUploadSlice.actions;
export default fileUploadSlice.reducer;
